export default "__VITE_ASSET__DEpIkY_H__"